import { render } from "./RoutineArchived.vue?vue&type=template&id=3ac60d34"
import script from "./RoutineArchived.vue?vue&type=script&lang=js"
export * from "./RoutineArchived.vue?vue&type=script&lang=js"

import "./RoutineArchived.vue?vue&type=style&index=0&id=3ac60d34&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__